import { gsap, ScrollTrigger } from "gsap/all";
//import "swiper/swiper-bundle.css";
import { debounce } from "../../resources/js/utils/delays";

gsap.registerPlugin(ScrollTrigger);

window.addEventListener("load", () => {
  const heroSections = gsap.utils.toArray(".section-hero");
  if (heroSections.lenght < 0) return;
  heroSections && heroSections.forEach(hero => {
    const heroItems = hero.querySelector('.section-hero__items-list');
    const mm = gsap.matchMedia();
    mm.add(
      {
        small: `(max-height: ${hero.clientHeight - 1}px)`,
        large: `(min-height: ${hero.clientHeight}px)`,
      },
      (ctx) => {
        const { large } = ctx.conditions;
        ScrollTrigger.create({
          trigger: hero,
          start: large ? "top top" : "bottom bottom",
          end: "+=100%",
          scrub: 1,
          pin: true,
          pinSpacing: false,
        });
      }
    );

    let clonedSlides = [];

    function cloneAllSlides() {
      const slides = heroItems.querySelectorAll('.section-hero__items-item');
      
      clonedSlides.length > 0 && clonedSlides.forEach(clone => heroItems.removeChild(clone));

      for (let i = 0; i < 3; i++) {
        slides.forEach(slide => {
          const clone = slide.cloneNode(true);
          clone.classList.add('clone');
          clonedSlides.push(clone);
          heroItems.appendChild(clone);
        });
      }
    }

    function destroySwiper() {
      heroItems.style.width = 'fit-content';
      const cloneSlides = heroItems.querySelectorAll('.section-hero__items-item.clone');
      cloneSlides.forEach(clone => heroItems.removeChild(clone));
      clonedSlides = [];
      heroItems.classList.remove('direction-left');
      updatePartnersSliderWidth();
    }

    const updatePartnersSliderWidth = () => {
      if (!heroItems) return;
      heroItems.style.width = `${heroItems.scrollWidth}px`;
    }

    const sliderInit = () => {
      cloneAllSlides();
      updatePartnersSliderWidth();
      const sliderCounts = [...heroItems.querySelectorAll('.section-hero__items-item')];
      heroItems.style.animationDuration = `${8 * sliderCounts.length}s`;
      heroItems.classList.add('direction-left');
    }

    const initSwiper = () => {
      const contentWidth = heroItems.scrollWidth;
      const viewportWidth = window.innerWidth;

      if(viewportWidth > 1024) {
        if(heroItems.classList.contains('direction-left')) {
          destroySwiper();
          (hero.querySelector('.section-hero__items-list').scrollWidth) > viewportWidth && sliderInit();
        } else if ((contentWidth) > viewportWidth) {
          !heroItems.classList.contains('direction-left') && sliderInit();
        }
      } else {
        !heroItems.classList.contains('direction-left') && sliderInit();
      }

      setTimeout(() => {
        updatePartnersSliderWidth();
      }, 300);
    }

    if(heroItems) {
      window.addEventListener('resize', debounce(initSwiper, 1500));
      initSwiper();
    }
  });
});
